import { VisibilityIcon } from '~/components/icons/generated/VisibilityIcon'

type Props = {
  count: number
}
export const ViewCounter: React.FC<Props> = ({ count }) => (
  <div className="flex items-center space-x-[3px] leading-[1.2]">
    <VisibilityIcon className="inline-block h-3 xl:h-5" />
    <span className="font-bold xl:text-[15px]">{count}</span>
  </div>
)
